import $ from "jquery";

const HAS_HOVER_CLASS_NAME = "t-has-hover";
let lastTouchTime = 0;

// Set has hover mode on
function enableHover() {
  // filter emulated events coming from touch events
  if (new Date() - lastTouchTime < 500) {
    return;
  }

  if ($("html").hasClass(HAS_HOVER_CLASS_NAME)) {
    return;
  }

  $("html").addClass(HAS_HOVER_CLASS_NAME);
}

// Set has hover mode off
function disableHover() {
  if (!$("html").hasClass(HAS_HOVER_CLASS_NAME)) {
    return;
  }

  $("html").removeClass(HAS_HOVER_CLASS_NAME);
}

// Save a timestamp of last touch event
function updateLastTouchTime() {
  lastTouchTime = new Date();
}

// Watch for mouse/touch events
function watchForHover() {
  $("html").get(0).addEventListener("touchstart", updateLastTouchTime, true);

  // On touch events, disable hover effects temporarily
  $("html").get(0).addEventListener("touchstart", disableHover, true);

  // On mouse move bring back hover effects
  // This is logical in cases where both capabilities are available (e.g touch enables laptops)
  $("html").get(0).addEventListener("mousemove", enableHover, true);
}

$(() => {
  watchForHover();
  // Assume hover is available until detected otherwise
  enableHover();
});



// WEBPACK FOOTER //
// ./src/frontend/common/page/has-hover.js